import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const AppAssessmentList = Loadable(lazy(() => import('pages/apps/assessment/list')));

const TeamList = Loadable(lazy(() => import('pages/apps/team/list')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));

const PatientListPage = Loadable(lazy(() => import('pages/apps/patient/lists')));
const PatientDetailsPage = Loadable(lazy(() => import('pages/apps/patient/details')));
const PatientAssessmentDetailsPage = Loadable(lazy(() => import('pages/apps/assessment/details')));
const RecentAssessments = Loadable(lazy(() => import('pages/apps/assessment/recent')));

const VisitTablePage = Loadable(lazy(() => import('pages/apps/visit/list')));
const VisitDetailsPage = Loadable(lazy(() => import('pages/apps/visit/details')));

const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'apps',
          children: [
            {
              path: 'profiles',
              children: [
                {
                  path: 'account',
                  element: <AccountProfile />,
                  children: [
                    {
                      path: 'my-account',
                      element: <AccountTabAccount />
                    },
                    {
                      path: 'password',
                      element: <AccountTabPassword />
                    }
                  ]
                }
              ]
            },
            {
              path: 'patients',
              children: [
                {
                  path: 'list',
                  element: <PatientListPage />
                },
                {
                  path: 'details/:id',
                  element: <PatientDetailsPage />
                }
              ]
            },
            {
              path: 'assessment',
              children: [
                {
                  path: 'templates',
                  element: <AppAssessmentList />
                },
                {
                  path: 'details/:id',
                  element: <PatientAssessmentDetailsPage />
                },
                {
                  path: 'list',
                  element: <RecentAssessments />
                }
              ]
            },
            {
              path: 'team',
              children: [
                {
                  path: 'list',
                  element: <TeamList />
                }
              ]
            },
            {
              path: 'visit',
              children: [
                {
                  path: 'list',
                  element: <VisitTablePage />
                },
                {
                  path: 'details/:id',
                  element: <VisitDetailsPage />
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        }
      ]
    }
  ]
};

export default MainRoutes;
